import type React from "react"
import { useState } from "react"
import { ReviewList } from "./ReviewList"
import { Edit3 } from "lucide-react"
import { useAppDispatch, useAppSelector } from "@/app/hooks"
import { selectIsAuthenticated, setLoginSheetOpen } from "@/features/auth/authSlice"
import { ReviewFormModal } from "./ReviewFormModal"
import type { ReviewResponse } from "@/types/review"
import "./ReviewSection.css"

type ReviewSectionProps = {
  siteId: string
}

export const ReviewSection: React.FC<ReviewSectionProps> = ({ siteId }) => {
  const dispatch = useAppDispatch()
  const isAuthenticated = useAppSelector(selectIsAuthenticated)

  const [isModalOpen, setIsModalOpen] = useState<boolean>(false)
  const [editingReview, setEditingReview] = useState<ReviewResponse | null>(null)

  const handleWriteReview = () => {
    if (!isAuthenticated) {
      dispatch(setLoginSheetOpen(true))
      return
    }
    setEditingReview(null)
    setIsModalOpen(true)
  }

  const handleEditReview = (review: ReviewResponse) => {
    setEditingReview(review)
    setIsModalOpen(true)
  }

  return (
    <div className="review-section">
      <div className="review-section-header">
        <h2 className="review-section-title">리뷰</h2>
      </div>

      <div className="review-action-area">
        <div className="review-prompt">이 캠핑장에 방문해 보셨나요?</div>
        <div className="review-sub-prompt">
          방문 인증하고 생생한 후기를 남겨주세요!
        </div>
        <button className="write-review-button" onClick={handleWriteReview}>
          <Edit3 size={18} />
          <span>방문 인증 / 리뷰 쓰기</span>
        </button>
      </div>

      <ReviewList siteId={siteId} onEdit={handleEditReview} />

      <ReviewFormModal
        isOpen={isModalOpen}
        onClose={() => { setIsModalOpen(false); }}
        siteId={siteId}
        review={editingReview}
      />
    </div>
  )
}
